import { EstadoContrato, cicloFact, TipoComp, TipoItem, Udm, Moneda } from "../../../isp.žapi.contratos/constantesApiContratos";

const tiposItem = [
    { label: "Plan de Internet", value: TipoItem.PlanInternet },
    { label: "Servicios Gener.", value: TipoItem.ServiciosGen },
    { label: "Servicios Gener.", value: TipoItem.ServiciosGen },
    { label: "Articulo", value: TipoItem.Articulo },
];

const udms = [
    { label: "Mensual", value: Udm.Mensual },
    { label: "Unidad", value: Udm.Unidad },
];

const monedas = [
    { label: "Soles (S/)", value: Moneda.Soles },
    { label: "Dólares ($)", value: Moneda.Dolares },
];

const tiposComprobantesCombo = [
    { label: "Recibo de Venta", value: TipoComp.Recibo },
    { label: "Factura", value: TipoComp.Factura },
    { label: "Boleta", value: TipoComp.Boleta },
];
const ciclosFactCombo = [
    { label: "15 del mes", value: cicloFact.quinceDeMes },
    { label: "Último dia del mes", value: cicloFact.ultimoDiaMes },
];

export { tiposComprobantesCombo, ciclosFactCombo, tiposItem, udms, monedas };
